import { render, staticRenderFns } from "./Actualiteviewer.vue?vue&type=template&id=1d561fbe&"
import script from "./Actualiteviewer.vue?vue&type=script&lang=js&"
export * from "./Actualiteviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports